import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withNamespaces} from 'react-i18next';
import './InstanceLoading.css';
import Paper from '@material-ui/core/Paper';
import logo from '../Sidebar/logo.png';
import { Button } from '@material-ui/core';


const InstanceLoading = (props) => {
    const {t} = props;
    if (!props.instance) {
        return (
            <div className="canvas">
                <div className="loadingWrapper">
                    <Paper className="paper">
                        <img src={logo} alt="PowerGym" className="logoLoading"/>
                        <p>{t("Loading Instance")}...</p>
                        <CircularProgress/>
                    </Paper>
                </div>
            </div>
        );
    }

    if (!props.instance.data) {
        return (
            <div className="canvas error">
                <Paper className="paper">
                    <h1>Error</h1>
                    <p>{t("We have an error")}: {props.instance.error.humanError || t("There is an unknown error. Contact support")}</p>
                    <pre>
                        {props.instance.error.devError}
                    </pre>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            if (caches) {
                                // Service worker cache should be cleared with caches.delete()
                                caches.keys().then((names) => {
                                  for (const name of names) {
                                    caches.delete(name);
                                  }
                                });
                              }
                              // delete browser cache and hard reload
                              window.location.reload(true);
                        }}
                    >
                        {t("Retry")}
                    </Button>
                </Paper>
            </div>
        );
    }
};

export default withNamespaces()(InstanceLoading);
